import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { SearchOrder } from "../EditOrder/SearchOrder";
import { FoundOrders } from "../EditOrder/FoundOrders";
import { OrderCancelledForm } from "./OrderCancelledForm";
import { OrderInfo } from "../AddOrder/OrderInfo";

import db from "../../../services/firebase";

const useStyles = makeStyles(() => ({
  title: {
    "& .MuiTypography-root": {
      display: "flex",
      justifyContent: "space-between",
    },
  },
  content: {
    minHeight: "50vh",
    padding: 0,
  },
  dialog: {
    "& .MuiDialog-container .MuiPaper-root": {
      minHeight: "90%",
      maxHeight: "90%",
    },
  },
}));

const DeleteOrderModal = ({ open, handleClose }) => {
  const classes = useStyles();

  const [orderStep, setOrderStep] = useState(1);
  const initialState = {
    fullname: "",
    telephone: "",
    orderID: "",
  };
  const [searchInfo, setSearchInfo] = useState(initialState);
  const [foundOrders, setFoundOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderInfo, setOrderInfo] = useState({});

  const initialCancelState = {
    reason: "wrong-address",
    notes: "",
  };
  const [cancelNotes, setCancelNotes] = useState(initialCancelState);

  const handleNext = () => {
    setOrderStep(orderStep + 1);
  };

  const handleLast = () => {
    setOrderStep(orderStep - 1);
  };

  const handleSearchOrder = async () => {
    let searchBy = Object.keys(searchInfo).find(
      (item) => searchInfo[item].length > 0
    );

    let searchCriteria = "fullname";
    switch (searchBy) {
      case "fullname":
        searchCriteria = "fullname";
        break;
      case "telephone":
        searchCriteria = "telephone";
        break;
      case "orderID":
        searchCriteria = searchBy;
        break;
      default:
        break;
    }

    try {
      if (searchCriteria !== "orderID") {
        const { docs } = await db
          .collection("orders")
          .where(searchCriteria, "==", searchInfo[searchBy])
          .limit(10)
          .get();

        if (docs.length) {
          const newArr = [];
          docs.map((doc) => newArr.push({ ...doc.data(), id: doc.id }));
          setFoundOrders(newArr);
          handleNext();
        } else {
          // LLAMAR NOTIFICACION
          console.log("No orders found.");
        }
      } else {
        const res = await db
          .collection("orders")
          .doc(searchInfo[searchBy])
          .get();
        // console.log(res.data());
        setFoundOrders([{ id: searchInfo[searchBy], ...res.data() }]);
        handleNext();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const validateForm = () => {
    const requiredFields = Object.keys(searchInfo);
    return requiredFields.some((item) => searchInfo[item].length > 0);
  };

  const handleFieldsChanges = (event) => {
    const { value, name } = event.target;
    setCancelNotes({ ...cancelNotes, [name]: value });
  };

  const handleCancelOrder = async () => {
    try {
      const cancelledObject = { ...orderInfo, reason: cancelNotes };
      await db
        .collection("cancelledOrders")
        .doc(cancelledObject.id)
        .set(cancelledObject);
      await db.collection("orders").doc(cancelledObject.id).delete();
      handleNext();
    } catch (error) {
      console.error(error);
    }
  };

  const handleCloseCancelOrderModal = () => {
    setOrderStep(1);
    setSearchInfo(initialState);
    setFoundOrders([]);
    setSelectedOrder(null);
    setOrderInfo({});
    handleClose();
  };

  //============================================================================
  // useEffects Hooks
  //============================================================================

  // Set OrderInfo when an order is selected
  useEffect(() => {
    if (selectedOrder) {
      setOrderInfo(foundOrders.find((order) => order.id === selectedOrder));
    } else {
      setOrderInfo({});
    }
  }, [selectedOrder, foundOrders]);

  return (
    <Dialog
      className={classes.dialog}
      fullWidth
      maxWidth="md"
      open={open}
      onClose={handleClose}
      disableBackdropClick={orderStep === 4}
      disableEscapeKeyDown={orderStep === 4}
    >
      <DialogTitle className={classes.title}>Cancelar Pedido</DialogTitle>
      <DialogContent className={classes.content}>
        {orderStep === 1 && (
          <SearchOrder searchInfo={searchInfo} setSearchInfo={setSearchInfo} />
        )}
        {orderStep === 2 && (
          <FoundOrders
            orders={foundOrders}
            selectedOrder={selectedOrder}
            setSelectedOrder={setSelectedOrder}
          />
        )}
        {orderStep === 3 && (
          <OrderCancelledForm
            fields={cancelNotes}
            handleFieldsChanges={handleFieldsChanges}
          />
        )}
        {orderStep === 4 && (
          <OrderInfo orderID={orderInfo.id} message={"Orden Cancelada"} />
        )}
      </DialogContent>
      <DialogActions>
        {orderStep === 1 && (
          <Button
            color="primary"
            disabled={!validateForm()}
            onClick={handleSearchOrder}
          >
            Buscar Orden
          </Button>
        )}
        {orderStep > 1 && orderStep < 4 && (
          <Button color="secondary" onClick={handleLast}>
            Anterior
          </Button>
        )}
        {orderStep === 2 && (
          <Button
            color="primary"
            disabled={!selectedOrder}
            onClick={handleNext}
          >
            Siguiente
          </Button>
        )}
        {orderStep === 3 && (
          <Button onClick={handleCancelOrder}>Cancelar Pedido</Button>
        )}
        {orderStep === 4 && (
          <Button onClick={handleCloseCancelOrderModal}>Cerrar</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DeleteOrderModal;
